import { render } from "./tab-menu.vue?vue&type=template&id=62a23127&scoped=true&ts=true"
import script from "./tab-menu.ts?vue&type=script&scoped=true&lang=ts"
export * from "./tab-menu.ts?vue&type=script&scoped=true&lang=ts"

import "./tab-menu.vue?vue&type=style&index=0&id=62a23127&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62a23127"]])

export default __exports__